module Client.Pages

open System
open Elmish.UrlParser

/// The different pages of the application. If you add a new page, then add an entry here.
[<RequireQualifiedAccess>]
type Page = 
    | Home 
    | Tenant of string
    | Admin of string * string
    | InfoPage of string * string
    | PasswordReset of Guid
    | AlcoholAudit of string
    | SelfReferral of string
    | ConfirmReferral of string * Guid
    | Training of string * string * string

let toHash =
    function
    | Page.Home -> "#home"
    | Page.Admin (tenant,action) -> sprintf "#areas/%s/admin/%s" tenant action
    | Page.InfoPage (tenant,slug) -> sprintf "#areas/%s/pages/%s" tenant slug
    | Page.PasswordReset guid -> sprintf "#password-reset/%O" guid
    | Page.ConfirmReferral (tenant,guid) -> sprintf "#areas/%s/confirm-referral/%O" tenant guid
    | Page.Tenant tenant -> sprintf "#areas/%s" tenant
    | Page.AlcoholAudit tenant -> sprintf "#areas/%s/alcohol-audit" tenant
    | Page.SelfReferral tenant -> sprintf "#areas/%s/referral" tenant
    | Page.Training (tenant,token,slug) -> sprintf "#training/%s/%s/%s" tenant token slug

let pGuid state =
    custom "pGuid" (Guid.TryParse >> function true, value -> Ok value | _ -> Error "Can't parse guid" ) state


/// The URL is turned into a Result.
let pageParser : Parser<Page->Page,_> =    
    oneOf [ 
        map Page.Home (s "home")
        map (fun area page -> Page.Admin(area,page)) (s "areas" </> str </> s "admin" </> str)   
        map (fun area page -> Page.InfoPage(area,page)) (s "areas" </> str </> s "pages" </> str)
        map Page.Tenant (s "areas" </> str) 
        map Page.PasswordReset (s "password-reset" </> pGuid)
        map (fun area id -> Page.ConfirmReferral(area,id)) (s "areas" </> str </> s "confirm-referral" </> pGuid)
        map Page.AlcoholAudit (s "areas" </> str </> s "alcohol-audit")
        map Page.SelfReferral (s "areas" </> str </> s "referral")
        map (fun area token page -> Page.Training(area,token,page)) (s "training" </> str </> str </> str)
    ]

let urlParser location = parse pageParser location
